<template>
    <div class="field">
        <label class="label">{{ $t("user-select.select-one-user") }}</label>
        <div class="control">
            <div class="select">
                <select v-model="selectedUser" @change="changeUser">
                    <option
                        v-for="user in users"
                        :value="user"
                        :key="user.id"
                    >
                        {{ user.name }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: "user-select",
    props: {
        value: Object,
        default: null,
    },
    data() {
        return {
            selectedUser: null,
        };
    },
    mounted() {
        this.selectedUser = this.value;
    },
    computed: {
        ...mapGetters("conference", ["getOtherUsers"]),
        users() {
            return this.getOtherUsers;
        },
    },
    methods: {
        changeUser() {
            this.$emit("input", this.selectedUser);
        },
    },
};
</script>